import { LoadingIcon, Stack } from '@cash-design-system/react'
import { ClientScenario } from '@cash-web/protos/squareup/franklin/api/client_scenario.pb'
import { useFlowContext } from '@cash-web/shared-flow-data-access-context'
import { StartWithClientScenarioProps } from '@cash-web/shared-flow-data-access-context'
import { useExecuteOnce } from '@cash-web/shared-util-execute-once'

type CompleteScenarioProps = {
  clientScenario: ClientScenario
  flowToken?: string
}

export const CompleteScenario = ({ clientScenario, flowToken }: CompleteScenarioProps) => {
  const flowConfig: StartWithClientScenarioProps = {
    clientScenario: clientScenario,
    trackingFlowName: clientScenario,
    queriesToInvalidate: 'ALL',
    flowToken,
  }

  const flow = useFlowContext()

  useExecuteOnce(async () => {
    flow.startWithClientScenario(flowConfig)
  })

  return (
    <Stack space="l" justifyItems="center">
      <LoadingIcon />
    </Stack>
  )
}
